import React, { useEffect, useState } from 'react'
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx"
import { Space } from 'antd';
import { GetPaymentGatewayStatusByIdApi } from '../../../api/request/client.js';
import toast from 'react-hot-toast';

function ZaroPayQR({ isOpenModal, setIsOpenModal, Depositdata }) {
    const [paymentGateway, setPaymentStatus] = useState({});

    const getPaymentGatewayStatus = async () => {
        try {
            let apiParams = {
                CRM_OrderId: Depositdata?.crM_OrderId
            }
            const { data } = await GetPaymentGatewayStatusByIdApi(new URLSearchParams(apiParams).toString());
            if (data?.success) {
                setPaymentStatus(data?.data);
                if (data?.data.order_status === "SUCCESS") {
                    setIsOpenModal(false)
                    toast.success("Payment has been successfully completed.");
                }

                const createdDate = new Date(data?.data?.createdDate);
                const currentDate = new Date();
                const fifteenMinutesInMs = 15 * 60 * 1000; // 15 minutes in milliseconds

                // Check if 15 minutes have passed
                if (currentDate - createdDate >= fifteenMinutesInMs) {
                    setIsOpenModal(false)
                    toast.success("Your payment link is expired, please try again.");
                }
            }
        } catch (error) {}
    }

    useEffect(() => {
        if (isOpenModal === true) {
            const intervalId = setInterval(getPaymentGatewayStatus, 5000);
            return () => clearInterval(intervalId);
        }
    }, [isOpenModal]);

    return (
        <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title="ZaroPay" width={1200}>
            <div className='container mx-auto flex justify-center items-center'>
                <div className="border-[2px] border-light rounded-xl p-6 w-full">
                    <h2 className="text-[#2F2B3D] text-xl font-semibold text-center whitespace-nowrap">
                        You can make the payment by using the address given below or by scanning the QR code
                    </h2>
                    <Space direction="vertical" align="center">
                        {/* <QRCode value={params?.id || '-'} /> */}
                        <img src={Depositdata?.qr_image} alt='QR' width={100} height={100} />
                    </Space>

                    <div className="flex flex-col mt-4">
                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Address to Pay:</h3>
                            <p className="ml-6">{Depositdata?.address_to_pay || "-"}</p>
                        </div>

                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Price (USD):</h3>
                            <p className="ml-6">{Depositdata?.price_usdt}</p>
                        </div>

                        <div className="flex mt-2">
                            <p className="text-sm">Note: Please double-check that we get the full amount shown below. Some wallets take out a fee from the amount sent, which can cause us to receive less.</p>
                        </div>

                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Amount to Pay:</h3>
                            <h3 className="font-semibold ml-6">{Depositdata?.amount_to_pay} USDT_TRC20</h3>
                        </div>
                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Status:</h3>
                            <p className="ml-6">{paymentGateway?.order_status}</p>
                        </div>

                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Order Id:</h3>
                            <p className="ml-6">{Depositdata?.order_id}</p>
                        </div>

                        <div className="flex mt-8">
                            <p>Thank you for your payment!</p>
                        </div>

                        <div className="flex mt-2">
                            <p>Note: If the transaction amount is less than 10 USDT, the order will fail. Please ensure your transaction meets the minimum amount requirement.</p>
                        </div>
                    </div>

                </div>

            </div>
        </ModalComponent >
    )
}

export default ZaroPayQR
